import React, {ReactNode} from 'react';
import {tryCall} from '@esgi/ui-kit/utils';
import {Transition} from './transition/transition';
import {getClassNameFor} from './utils';
import {AnimatableElement, AnimationState, ClassNamesProp, DurationProp, StateChangedCallback} from './types';

export interface AnimationProps {
	in: boolean;
	duration: DurationProp;
	classNames: ClassNamesProp;
	onStateChanged?: StateChangedCallback;
	children: ReactNode;
}

export class ClassNameAnimation extends React.Component<AnimationProps> {
	private updateClassName = (state: AnimationState, element: AnimatableElement) => {
		for (const state of ['enter', 'exit', 'initial']) {
			const className = getClassNameFor(state as AnimationState, this.props.classNames);
			if (className) {
				element.classList.remove(className);
			}
		}

		const className = getClassNameFor(state, this.props.classNames);
		if (className) {
			element.classList.add(className);
		}
		tryCall(this.props.onStateChanged, state, element);
	};

	public override render() {
		return <Transition in={this.props.in} duration={this.props.duration} beforeStateChanged={this.updateClassName}>
			{this.props.children}
		</Transition>;
	}
}
